import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ITableConfig } from '../../../interfaces/table/table-config';
import { ITableDataOption } from '../../../interfaces/table/table-data-option';
import { ITableExtraParams } from '../../../interfaces/table/table-extra-params';
import { ITableHeaderOption } from '../../../interfaces/table/table-header-option';
import { ITableOrder } from '../../../interfaces/table/table-order';
import { IPaginationOption } from '../../../interfaces/table/table-pagination-option';
import { objectPathExists } from '../../../services/utils/utilities';

@Component({
  selector: 'app-main-table',
  templateUrl: './main-table.component.html',
  styleUrls: ['./main-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainTableComponent implements OnChanges {
  @Output() public sendInfoToComponent = new EventEmitter<any>();

  @Input()
  public set tableConfig(tableConfig: ITableConfig) {
    if (tableConfig) {
      this.tableHeaders = tableConfig.header;
      this.tableDataset = tableConfig.dataset;
      this.originalDataset = [...tableConfig.dataset];
      this.extraParams = tableConfig.extraParams;

      this.quantityPerPage =
        tableConfig.extraParams && tableConfig.extraParams.quantityPerPage ? tableConfig.extraParams.quantityPerPage : 10; // Valor por defecto 10

      this.pagination = {
        quantityPerPage: this.quantityPerPage,
        dataLength: this.tableDataset ? this.tableDataset.length : 0,
      };
    }
  }

  public dataSort: ITableOrder;
  public quantityPerPage: number;
  public currentPage: number;
  public pagination: IPaginationOption;
  public tableHeaders: ITableHeaderOption[];
  public tableDataset: ITableDataOption[][];
  public originalDataset: ITableDataOption[][];
  public extraParams: ITableExtraParams;

  constructor(private cdr: ChangeDetectorRef) {
    this.dataSort = null;
    this.pagination = null;
  }

  /**
   * On component changes
   */
  public ngOnChanges(changes: SimpleChanges): void {
    if (objectPathExists(changes, 'tableConfig.currentValue.extraParams.quantityPerPage')) {
      const { quantityPerPage } = changes.tableConfig.currentValue.extraParams;
      this.changeQuantity(quantityPerPage || 10);
      this.currentPage = 1;
    }
  }

  /**
   * Function to sort by key in DataTableComponent
   */
  public sortByKey($event: ITableOrder): void {
    if (!this.originalDataset || !Array.isArray(this.originalDataset)) {
      console.warn('originalDataset not initialized');
      return;
    }

    if ($event.order === null) {
      this.tableDataset = [...this.originalDataset];
      this.dataSort = null;
    } else {
      const sortedDataset = [...this.originalDataset].sort((a, b) => {
        const columnIndex = this.tableHeaders.findIndex((header) => $event.key === header.sortBy || $event.key === header.value);
        if (columnIndex === -1) return 0;

        const aValue = a[columnIndex]?.value || '';
        const bValue = b[columnIndex]?.value || '';

        const aNum = Number(aValue);
        const bNum = Number(bValue);
        const isNumeric = !isNaN(aNum) && !isNaN(bNum);

        if (isNumeric) {
          return $event.order === 'asc' ? aNum - bNum : bNum - aNum;
        }
        const comparison = String(aValue).localeCompare(String(bValue));
        return $event.order === 'asc' ? comparison : -comparison;
      });

      this.tableDataset = sortedDataset;
      this.dataSort = $event;
    }

    this.dataSort = null;

    this.cdr.markForCheck();
  }

  /**
   * Function to change the register quantity per page
   * @param $event new quantity
   */
  public changeQuantity($event: number): void {
    this.quantityPerPage = Number($event) || 10;
    this.pagination = {
      quantityPerPage: this.quantityPerPage,
      dataLength: this.tableDataset ? this.tableDataset.length : 0,
    };
    this.cdr.markForCheck();
  }

  /**
   * Function to change page in table
   * @param $event new page
   */
  public changePage($event: number): void {
    this.currentPage = $event;
  }
}
